import { useState, useEffect } from "react";

export default function HighlightButton() {
  const [highlightUrl, setHighlightUrl] = useState(
    localStorage.getItem("highlight_url") || null
  );

  useEffect(() => {
    const url =
      "https://gist.githubusercontent.com/tuhindutta/ccc002898dd712edbd407848db62db48/raw/highlight.json";

    fetch(url, { cache: "no-store" })
      .then(res => res.json())
      .then(data => {
        const newUrl = data?.highlightUrl?.trim() || null;

        // If valid and changed – update UI + cache
        if (newUrl) {
          localStorage.setItem("highlight_url", newUrl);
          setHighlightUrl(newUrl);
        } else {
          // If gist intentionally cleared – remove + hide
          localStorage.removeItem("highlight_url");
          setHighlightUrl(null);
        }
      })
      .catch(() => {
        // On failure do nothing — keep last known good value
      });
  }, []);

  // No highlight at all – hide
  if (!highlightUrl) return null;

  return (
    <a
      href={highlightUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center justify-center rounded-full bg-white px-6 py-3 text-sm font-semibold text-gray-800 no-underline shadow-sm border border-gray-300 transition hover:border-blue-400 hover:bg-blue-50"
    >
      ⭐ Highlight
    </a>
  );
}
